import { response } from "app/helpers/commonInterface";
import {
  GET_TASK_OVERVIEW_FAILURE,
  GET_TASK_OVERVIEW_REQUEST,
  GET_TASK_OVERVIEW_SUCCESS,
} from "../actionTypes";
import { taskData, taskOverview } from "./taskDataInterface";

export interface taskOverviewState {
  loading: boolean;
  taskOverview: response<taskOverview>;
  error: string;
}

interface action {
  type: string;
  payload: any;
}

const initialState: taskOverviewState = {
  loading: false,
  taskOverview: {},
  error: "",
};

export const taskOverviewReducer = (state = initialState, action: action) => {
  switch (action.type) {
    case GET_TASK_OVERVIEW_REQUEST:
      return {
        loading: true,
      };
    case GET_TASK_OVERVIEW_SUCCESS:
      return {
        loading: false,
        taskOverview: action.payload,
        error: "",
      };
    case GET_TASK_OVERVIEW_FAILURE:
      return {
        loading: false,
        taskOverview: {},
        error: action.payload,
      };
    default:
      return state;
  }
};
